'use client';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Children, cloneElement, isValidElement } from 'react';
import { useFieldContext } from './FieldContext';
/**
 * Compound member of <Field>. Slot wrapper that injects id and ARIA attributes
 * from FieldContext into its single child element. Used in the 10% slot
 * decomposition case when you need manual composition.
 *
 * <Field>
 *   <Field.Label>Email</Field.Label>
 *   <Field.Control><Input type="email" /></Field.Control>
 *   <Field.Description>We'll never share it.</Field.Description>
 *   <Field.Error>{errors.email}</Field.Error>
 * </Field>
 */
export function FieldControl({ children }) {
    const ctx = useFieldContext();
    if (!ctx)
        return _jsx(_Fragment, { children: children });
    const child = Children.only(children);
    if (!isValidElement(child))
        return _jsx(_Fragment, { children: children });
    const el = child;
    const describedBy = [ctx.describedBy, el.props['aria-describedby']]
        .filter((id) => id !== undefined && id !== '')
        .join(' ');
    return cloneElement(el, {
        id: ctx.ids.control,
        ...(describedBy !== '' ? { 'aria-describedby': describedBy } : {}),
        ...(ctx.invalid ? { 'aria-invalid': true } : {}),
        ...(ctx.required ? { 'aria-required': true } : {}),
    });
}
//# sourceMappingURL=FieldControl.js.map